
import { defineComponent, computed } from 'vue'

const __default__ = defineComponent({
  name: 'StockCodeDisplay',
  props: {
    symbol: {
      type: String,
      required: true,
      default: ''
    },
    market: {
      type: String,
      required: true,
      default: ''
    },
    showMarket: {
      type: Boolean,
      default: true
    },
    // 港股延时标识
    hkDelay: {
      type: Boolean,
      default: false
    },
    // 美股延时标识
    usDelay: {
      type: Boolean,
      default: false
    },
    // 主题：'dark' | 'light'
    theme: {
      type: String,
      default: 'dark'
    }
  },
  setup(props) {
    // 获取市场标签
    const marketLabel = computed(() => {
      const market = props.market
      if (!market) return ''
      
      if (market === 'HKSE' || market === 'DELAY_HKSE') {
        return 'HK'
      }
      if (market === 'NYSE' || market === 'NASDAQ' || market === 'DELAY_US' || market.includes('US')) {
        return 'US'
      }
      return ''
    })

    // 获取市场标签颜色
    const marketColor = computed(() => {
      const market = props.market
      if (!market) return '#FFFFFF'
      
      if (market === 'HKSE' || market === 'DELAY_HKSE') {
        return '#FFD700' // 黄色
      }
      if (market === 'NYSE' || market === 'NASDAQ' || market === 'DELAY_US' || market.includes('US')) {
        return '#1890FF' // 蓝色
      }
      return '#FFFFFF' // 默认白色
    })

    // 是否显示延时标识
    const isDelayed = computed(() => {
      const market = props.market
      if (!market) return false

      const isHK = market === 'HKSE' || market === 'DELAY_HKSE'
      const isUS = market === 'NYSE' || market === 'NASDAQ' || market === 'DELAY_US' || market.includes('US')

      if (isHK && props.hkDelay) return true
      if (isUS && props.usDelay) return true

      // 兼容旧的 DELAY_ 前缀方式
      return market.startsWith('DELAY_')
    })

    return {
      marketLabel,
      marketColor,
      isDelayed
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "e858ebc8": (_ctx.theme === "light" ? "#333333" : "#ffffff")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__